import * as React from "react"
const UploadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={54}
    viewBox="0 0 72 54"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M36 6c10.359 0 17.673 8.391 16.701 20.34C57.936 26.202 66 28.593 66 37.5 66 43.29 61.29 48 55.5 48h-39C10.71 48 6 43.29 6 37.5c0-8.391 7.437-11.499 13.299-11.16C18.798 13.686 25.923 6 36 6Zm0-6C23.982 0 14.199 9.423 13.563 21.276 5.853 22.665 0 29.394 0 37.5 0 46.611 7.389 54 16.5 54h39C64.611 54 72 46.611 72 37.5c0-8.106-5.853-14.835-13.563-16.224C57.801 9.423 48.018 0 36 0Zm12 30h-9v12h-6V30h-9l12-12 12 12Z"
    />
  </svg>
)
export default UploadIcon;
